import type { ReactNode } from "react";
import { Drawer } from "@constructorfleet/ui";

export function SlidePanel({
  open,
  title,
  onClose,
  actions,
  children,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Drawer open={open} title={title} onClose={onClose} actions={actions}>
      {children}
    </Drawer>
  );
}
